// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2jWUe","name":"Header_name__3Qbwy","birthday":"Header_birthday__1NNvW","skeleton":"Header_skeleton__1d-X1"};